"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CodeManagerUpdateSchema = exports.CodeManagerUpdateScalarSchema = exports.CodeManagerCreateSchema = exports.CodeManagerCreateScalarSchema = exports.CodeManagerPrismaUpdateSchema = exports.CodeManagerPrismaCreateSchema = exports.CodeManagerSchema = exports.CodeManagerScalarSchema = void 0;
// @ts-nocheck
const zod_1 = require("zod");
const baseSchema = zod_1.z.object({
    id: zod_1.z.string().uuid(),
    codeName: zod_1.z.string(),
    attachedDiscountRange: zod_1.z.string(),
    descriptionEN: zod_1.z.string(),
    descriptionFR: zod_1.z.string(),
    createdAt: zod_1.z.coerce.date().default(() => new Date()),
    updatedAt: zod_1.z.coerce.date().default(() => new Date()),
    durationInDays: zod_1.z.number(),
}).strict();
/**
 * `CodeManager` schema excluding foreign keys and relations.
 */
exports.CodeManagerScalarSchema = baseSchema;
/**
 * `CodeManager` schema including all fields (scalar, foreign key, and relations) and validations.
 */
exports.CodeManagerSchema = exports.CodeManagerScalarSchema;
/**
 * Schema used for validating Prisma create input. For internal use only.
 * @private
 */
exports.CodeManagerPrismaCreateSchema = baseSchema.partial().passthrough();
/**
 * Schema used for validating Prisma update input. For internal use only.
 * @private
 */
exports.CodeManagerPrismaUpdateSchema = zod_1.z.object({
    id: zod_1.z.string().uuid(),
    codeName: zod_1.z.string(),
    attachedDiscountRange: zod_1.z.string(),
    descriptionEN: zod_1.z.string(),
    descriptionFR: zod_1.z.string(),
    createdAt: zod_1.z.coerce.date().default(() => new Date()),
    updatedAt: zod_1.z.coerce.date().default(() => new Date()),
    durationInDays: zod_1.z.union([zod_1.z.number(), zod_1.z.record(zod_1.z.unknown())])
}).partial().passthrough();
/**
 * `CodeManager` schema for create operations excluding foreign keys and relations.
 */
exports.CodeManagerCreateScalarSchema = baseSchema.partial({
    createdAt: true, updatedAt: true
});
/**
 * `CodeManager` schema for create operations including scalar fields, foreign key fields, and validations.
 */
exports.CodeManagerCreateSchema = baseSchema.partial({
    createdAt: true, updatedAt: true
});
/**
 * `CodeManager` schema for update operations excluding foreign keys and relations.
 */
exports.CodeManagerUpdateScalarSchema = baseSchema.partial();
/**
 * `CodeManager` schema for update operations including scalar fields, foreign key fields, and validations.
 */
exports.CodeManagerUpdateSchema = exports.CodeManagerUpdateScalarSchema;
